import { AttachMoney as AttachMoneyIcon } from '@mui/icons-material';

const DollarSign = (): JSX.Element => <AttachMoneyIcon fontSize="inherit" />;

export default DollarSign;
